import React from 'react';
import {
    TOTAL_LIST_WIDTH,
    cellStyle,
    COL_WIDTHS,
    cnsumColor,
} from "./helpers";

export function TaskListTable({
  tasks,
  rowHeight,
  selectedTaskId,
  setSelectedTask,
  expandedEpics,
  toggleEpicAccordion,
  onOpenCreateUserStoryModal,
  onOpenEditUserStoryAttributesModal,
  onOpenManageDependenciesModal,
}) {
  const maxTitleLength = 38;

  return (
    <div
      style={{
        width: TOTAL_LIST_WIDTH,
        borderLeft: "1px solid #E5E7EB",
      }}
    >
      {tasks.map((task, index) => {
        if (task.rowKind === "storyMain") {
          const story = task.storyRef;
          const epicId = task.id.split("-")[1];
          return(
            <div
              key={task.id}
              style={{
                display: "flex",
                height: rowHeight,
                alignItems: "center",
                background: "#FFFFFF",
                borderBottom: "1px solid #E5E7EB",
              }}
            >
              <div
                style={cellStyle(COL_WIDTHS.item, {
                  justifyContent: "flex-start",
                  paddingLeft: 44,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 6,
                })}
              >
                <button
                  type="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    onOpenManageDependenciesModal(story.id, story.subject, "story");
                  }}
                  title="Gerenciar dependências"
                  style={{
                    width: 22,
                    height: 22,
                    borderRadius: 9999,
                    border: "1px solid #D1D5DB",
                    background: "#FFFFFF",
                    color: "#6366F1",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    fontSize: 12,
                    fontWeight: 700,
                    flexShrink: 0,
                    transition: "all 0.15s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#EEF2FF";
                    e.currentTarget.style.borderColor = "#C7D2FE";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#FFFFFF";
                    e.currentTarget.style.borderColor = "#D1D5DB";
                  }}
                >
                  <svg width="13" height="13" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8 1.5C4.13623 1.5 1 4.63623 1 8.5C1 12.3638 4.13623 15.5 8 15.5C11.8638 15.5 15 12.3638 15 8.5C15 4.63623 11.8638 1.5 8 1.5ZM11 8.5C11 9.32843 10.3284 10 9.5 10C8.67157 10 8 9.32843 8 8.5C8 7.67157 8.67157 7 9.5 7C10.3284 7 11 7.67157 11 8.5ZM5.5 10C4.67157 10 4 9.32843 4 8.5C4 7.67157 4.67157 7 5.5 7C6.32843 7 7 7.67157 7 8.5C7 9.32843 6.32843 10 5.5 10Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>

                <span
                  onClick={() => onOpenEditUserStoryAttributesModal(story, epicId)}
                  style={{
                    fontWeight: 600,
                    cursor: "pointer",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    minWidth: 0,
                  }}
                  title={story.subject || story.name}
                >
                  {story.subject || story.name}
                </span>
              </div>
              <div style={cellStyle(COL_WIDTHS.horasPrev)}>
                {story.estimated_hours ?  `${story.estimated_hours}h` : "-"}
              </div>
              <div style={cellStyle(COL_WIDTHS.horasReal, {
                color: "#F59E0B",
                fontWeight: 600,
              })}>
                {story.horasReais ? `${story.horasReais}h` : "-"}
              </div>
              <div style={cellStyle(COL_WIDTHS.cnsum, {
                color: cnsumColor(task.cnsum),
                fontWeight: 700,
              })}>
                {task.cnsum !== null ? `${task.cnsum}%` : "-"}
              </div>
              <div style={cellStyle(COL_WIDTHS.progresso)}>
                {story.progress ? `${story.progress}%` : "-"}
              </div>
            </div>
          );
        }
        if (task.rowKind && task.rowKind !== "main") {
          const label = {
            consumo: "Consumo",
            progresso: "Progresso",
            execucao: "Execução",
            emptyStories: "Nenhuma história de usuário encontrada",
            loadingStories: "Carregando histórias...",
          }[task.rowKind];
          return(
            <div
              key={task.id}
              style={{
                display: "flex",
                height: rowHeight,
                alignItems: "center",
                borderBottom: "1px solid #E5E7EB"
              }}
            >
              <div
                style={
                  cellStyle(
                    COL_WIDTHS.item,
                    {
                      justifyContent: "flex-start",
                      paddingLeft: 40,
                      color: "#9CA3AF",
                      fontSize: 11,
                    },
                  )
                }
              >
                {label}
              </div>
              <div style={cellStyle(COL_WIDTHS.horasPrev)}>-</div>
              <div style={cellStyle(COL_WIDTHS.horasReal)}>-</div>
              <div style={cellStyle(COL_WIDTHS.cnsum)}>
                {task.rowKind === "consumo" && task.cnsum !== null ? `${task.cnsum}` : "-"}
              </div>
              <div style={cellStyle(COL_WIDTHS.progresso)}>
                {task.rowKind === "progresso" ? `${task.progressPct}` : "-"}
              </div>
            </div>
          );
        }
        const isSelected = task.id === selectedTaskId;
        const isProject = task.type === "project";
        const cnsum = task.cnsum;
        const truncated =
          task.name.length > maxTitleLength
            ? task.name.slice(0, maxTitleLength) + "…"
            : task.name;
        const epicId = String(task.id);
        const isExpanded = !!expandedEpics[epicId];

        return (
          <React.Fragment key={task.id}>
            <div
              onClick={() => setSelectedTask(task.id)}
              style={{
                display: "flex",
                height: rowHeight,
                alignItems: "center",
                background: isSelected
                  ? "#EFF6FF"
                  : index % 2 === 0
                  ? "#FFFFFF"
                  : "#F9FAFB",
                borderBottom: "1px solid #E5E7EB",
                cursor: "pointer",
                transition: "background 0.15s",
              }}
            >
              {/* ITEM */}
              <div
                style={{
                  ...cellStyle(COL_WIDTHS.item, {
                    justifyContent: "flex-start",
                    paddingLeft: isProject ? 8 : 24,
                    fontWeight: isProject ? 700 : 400,
                    color: isProject ? "#1D4ED8" : "#111827",
                    fontSize: isProject ? 13 : 12,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: 0,
                  }),
                }}
              >
                <button
                  type="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    toggleEpicAccordion(epicId);
                  }}
                  style={{
                    width: 26,
                    height: 26,
                    borderRadius: 9999,
                    border: "1px solid #D1D5DB",
                    background: "#FFFFFF",
                    color: "#374151",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    fontSize: 14,
                    fontWeight: 700,
                    flexShrink: 0,
                  }}
                >
                  {isExpanded ? 
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z"
                        fill="currentColor"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                      >
                      </path>
                    </svg>
                  :
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z"
                        fill="currentColor"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                      >
                      </path>
                    </svg>
                  }
                </button>
                <button
                  type="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    onOpenManageDependenciesModal(task.id, task.name, "epic");
                  }}
                  title="Gerenciar dependências"
                  style={{
                    width: 26,
                    height: 26,
                    borderRadius: 9999,
                    border: "1px solid #D1D5DB",
                    background: "#FFFFFF",
                    color: "#6366F1",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    fontSize: 14,
                    fontWeight: 700,
                    flexShrink: 0,
                    transition: "all 0.15s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#EEF2FF";
                    e.currentTarget.style.borderColor = "#C7D2FE";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#FFFFFF";
                    e.currentTarget.style.borderColor = "#D1D5DB";
                  }}
                >
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 1.5C4.13623 1.5 1 4.63623 1 8.5C1 12.3638 4.13623 15.5 8 15.5C11.8638 15.5 15 12.3638 15 8.5C15 4.63623 11.8638 1.5 8 1.5ZM11 8.5C11 9.32843 10.3284 10 9.5 10C8.67157 10 8 9.32843 8 8.5C8 7.67157 8.67157 7 9.5 7C10.3284 7 11 7.67157 11 8.5ZM5.5 10C4.67157 10 4 9.32843 4 8.5C4 7.67157 4.67157 7 5.5 7C6.32843 7 7 7.67157 7 8.5C7 9.32843 6.32843 10 5.5 10Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
                <button
                  type="button"
                  onClick={() => onOpenCreateUserStoryModal(epicId)}
                  style={{
                    padding: "6px 12px",
                    background: "#09d955",
                    color: "#FFFFFF",
                    border: "none",
                    borderRadius: 6,
                    fontSize: 12,
                    fontWeight: 600,
                    cursor: "pointer",
                    transition: "background 0.15s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "#15803D")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "#09d955")}
                >
                  + Criar História
                </button>
                {isProject && (
                  <span
                    style={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      background: "#1D4ED8",
                      marginRight: 6,
                      flexShrink: 0,
                    }}
                  />
                )}
                <div
                  title={task.name}
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    minWidth: 0,
                  }}
                >
                  {truncated}
                </div>
              </div>

              {/* HORAS prev */}
              <div style={cellStyle(COL_WIDTHS.horasPrev, { color: "#374151" })}>
                {task.horasPrevistas ? `${task.horasPrevistas}h` : "—"}
              </div>

              {/* HORAS real */}
              <div style={cellStyle(COL_WIDTHS.horasReal, { color: "#F59E0B", fontWeight: 600 })}>
                {task.horasReais ? `${task.horasReais}h` : "—"}
              </div>

              {/* CNSUM */}
              <div
                style={cellStyle(COL_WIDTHS.cnsum, {
                  color: cnsumColor(cnsum),
                  fontWeight: 700,
                })}
              >
                {cnsum !== null ? `${cnsum}%` : "—"}
              </div>

              {/* % concluído */}
              <div style={cellStyle(COL_WIDTHS.progresso, { flexDirection: "column", gap: 2 })}>
                <span style={{ fontWeight: 600, color: "#111827", fontSize: 12 }}>
                  {task.progress ? `${task.progress}%` : "—"}
                </span>
                {task.progress > 0 && (
                  <div
                    style={{
                      width: 52,
                      height: 4,
                      borderRadius: 2,
                      background: "#E5E7EB",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        width: `${Math.min(task.progress, 100)}%`,
                        height: "100%",
                        background:
                          task.progress >= 100 ? "#09d955" : "#3B82F6",
                        borderRadius: 2,
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}